<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.academic.operation.classOperation.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('school.academic.operation.classOperation.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-whitespace-no-wrap ts-justify-between">
          <ts-button color="info" outline @click="$router.push({ name: 'class-operation-create' })">{{ $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 250px" class="inline-block" />
            <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
            <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
              @close="() => (visible = false)" :zIndex="1020" width="300px">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <ts-branch-filter @filter="value => (branch_id = value)" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="ts-text-xs">
                      {{
                        $t('school.academic.operation.classOperation.status')
                      }}
                    </label>
                    <a-select class="ts-w-full" v-model="status" mode="multiple">
                      <a-select-option :value="1">{{
                        $t('classoperation.current')
                      }}</a-select-option>
                      <a-select-option :value="2">{{
                        $t('classoperation.history')
                      }}</a-select-option>
                      <a-select-option :value="3">{{
                        $t('classoperation.next')
                      }}</a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :showCheckbox="true" :rowGroup="{
          field: 'sub_program.acps_name_foreign'
        }">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch ? record.branch.branch_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{
                record.year.ac_year == record.term.academic_year.ac_year
                  ? record.term.academic_year.ac_year
                  : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.term.term_name }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.class_name }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              <a href="#" class="mr-2 text-primary" v-tooltip="$t('school.academic.operation.classOperation.student')
                " @click.prevent="showStudentList(record)">
                <span class="badge badge-primary">{{
                  record.students_count
                }}</span>
              </a>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.grade.grade_name_foreign }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.academic_year }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.academic_term }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.subject ? record.subject.subject_name_foreign : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.room ? record.room.room_name : '' }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.weekday_type ? record.weekday_type.weekday_type : '' }}
              <small>
                {{
                  record.weekday_type
                    ? record.weekday_type.is_required_study_time
                      ? ' (Required study time: No)'
                      : ' (Required study time: Yes)'
                    : ''
                }}</small>
            </td>
            <td class="ts-whitespace-no-wrap">
              <span v-if="record.academic_study_times">
                {{
                  record.academic_study_times
                    ? record.academic_study_times.study_time
                    : ''
                }}
                {{
                  record.academic_study_times
                    ? ' | ' + record.academic_study_times.session
                    : ''
                }}
                {{
                  record.academic_study_times.number_of_session
                    ? ' | Session Order: ' +
                    moment(
                      record.academic_study_times.number_of_session,
                      'D'
                    ).format('Do')
                    : ''
                }}
              </span>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.teacher ? record.teacher.full_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span class="badge badge-green" v-if="record.ac_status_id == 1">Current</span>
              <span class="badge badge-secondary" v-if="record.ac_status_id == 2">History</span>
              <span class="badge badge-info" v-if="record.ac_status_id == 3">Next</span>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span class="badge badge-success" v-if="record.required_thesis == 1">Yes</span>
              <span class="ios-close-circle-outline badge bg-danger" v-if="record.required_thesis == 0">No</span>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.created_by.employee.name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.modified_by ? record.modified_by.employee.name_en : ''
              }}
            </td>
            <td class="text-left ts-whitespace-no-wrap">
              <a href="#" class="mr-2 text-primary" v-tooltip="$t('school.academic.operation.classOperation.student')
                " @click.prevent="showStudentList(record)">
                <i class="fas fa-users"></i>
              </a>
              <a href="#" class="mr-2 text-primary" @click.prevent="edit(record)" v-tooltip="$t('edit')">
                <i class="fas fa-edit"></i>
              </a>
              <a href="#" class="text-info ts-mr-2" @click.prevent="copyClass(record)" :disabled="record._deleting"
                v-tooltip="$t('copy')">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-copy" v-else></i>
              </a>
              <a href="#" class="text-danger" @click.prevent="destroy(record)" :disabled="record._deleting"
                v-tooltip="$t('delete')">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <!-- view student list -->
      <a-modal v-model="show_student_list" centered @ok="() => (show_student_list = false)" :zIndex="1020"
        :cancelText="$t('cancel')" :okText="$t('ok')" :footer="null" width="50%">
        <template v-slot:title>
          <div class="ts-flex ts-justify-between ts-items-baseline">
            <div>
              <h2>
                {{ $t('school.academic.operation.classOperation.studentList') }}
              </h2>
            </div>
            <div class="ts-pr-4">
              <div class="ts-flex">
                <h4>{{ classInfo.class_name }} |</h4>
                <h4>{{ classInfo.teacher_name }} |</h4>
              </div>
            </div>
          </div>
        </template>
        <student-list :student="student_lists" :loading="refreshingStudentList" @student-deleted="handleStudentDeleted" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import StudentList from './components/view-student-list'
import moment from 'moment'
export default {
  name: 'classOperation',
  components: {
    StudentList
  },
  data() {
    return {
      visible: false,
      loading: false,
      all_year: false,
      show_student_list: false,
      refreshingStudentList: false,
      student_lists: [],
      classInfo: {},
      branch_id: []
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('classOperation', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.classOperation.search
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_SEARCH', newValue)
        this.$store.commit('classOperation/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('school.academic.operation.classOperation.branch')
        },
        {
          name: this.$t(
            'school.academic.operation.classOperation.academicYear'
          ),
          style: 'text-align:center; width:3%',
          sortKey: 'year.ac_year'
        },
        {
          name: this.$t('school.academic.operation.classOperation.term'),
          style: 'text-align:center; width:3%',
          sortKey: 'term.term_name'
        },
        {
          name: this.$t('school.academic.operation.classOperation.className'),
          sortKey: 'class_name'
        },
        {
          name: this.$t('school.academic.operation.classOperation.student'),
          style: 'text-align:center'
        },
        {
          name: this.$t('school.academic.operation.classOperation.grade'),
          sortKey: 'grade.grade_name_foreign'
        },
        {
          name: this.$t('school.academic.operation.classOperation.year'),
          style: 'text-align:center; width:3%',
          sortKey: 'academic_year'
        },
        {
          name: this.$t('school.academic.operation.classOperation.semester'),
          style: 'text-align:center; width:3%',
          sortKey: 'academic_term'
        },
        {
          name: this.$t('school.academic.operation.classOperation.subjectName'),
          sortKey: 'subject.subject_name_foreign'
        },
        {
          name: this.$t('school.academic.operation.classOperation.room'),
          sortKey: 'room.room_name'
        },
        {
          name: this.$t('school.academic.operation.classOperation.weekdayType'),
          style: 'text-align:center'
        },
        {
          name: this.$t('school.academic.operation.classOperation.studyTime'),
          sortKey: 'study_time'
        },
        {
          name: this.$t('school.academic.operation.classOperation.lecturer'),
          sortKey: 'teacher.fname_foreign'
        },
        {
          name: this.$t('school.academic.operation.classOperation.status'),
          style: 'text-align:center'
        },
        {
          name: this.$t(
            'school.academic.operation.classOperation.requiredThesis'
          ),
          style: 'text-align:center'
        },
        {
          name: this.$t('school.academic.operation.classOperation.createdBy')
        },
        {
          name: this.$t('school.academic.operation.classOperation.modifiedBy')
        },
        {
          name: this.$t('school.academic.operation.classOperation.actions'),
          style: 'width:7%; text-align:left'
        }
      ]
    },
    status: {
      get() {
        return this.$store.state.classOperation.ac_status_id
      },
      set(newValue) {
        this.$store.commit('classOperation/SET_STATUS_ID', newValue)
      }
    }
  },
  methods: {
    moment,
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'classOperation/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit(record) {
      this.$store.commit('classOperation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'class-operation-edit',
        params: { id: record.class_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('classOperation/destroy', record.class_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    async copyClass(record) {
      this.$store.commit('classOperation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'class-operation-copy-class',
        params: { id: record.class_id }
      })
    },
    showStudentList(record) {
      this.show_student_list = true
      this.classInfo = {
        class_name: record.class_name,
        teacher_name: record.teacher ? record.teacher.full_name_en : ''
      }
      this.student_lists = record.students
    },
    handleStudentDeleted(record) {

      this.refreshingStudentList = true

      this.student_lists = this.student_lists.filter(
        student => student.st_class_id !== record.st_class_id
      )
      this.fetchData().finally(() => {
        this.refreshingStudentList = false
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    status: debounce(function (value) {
      this.fetchData({ branch_id: this.branch_id })
    }, 500)
  }
}
</script>
